import axios from '@/axios/axios'

export default {
    namespaced: true, 
    actions:{
        addImage(context, formData) {
            return axios
            .post('/api/file/imageUpload', formData)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.log(error)
                return Promise.reject(error)
            })
        }
    }
}